export default __webpack_public_path__ + "static/media/favbook.0b6990b7.svg";